import { render } from "./auth-signup-success.vue?vue&type=template&id=5b895e88&scoped=true&ts=true"
import script from "./auth-signup-success.vue?vue&type=script&lang=ts"
export * from "./auth-signup-success.vue?vue&type=script&lang=ts"

import "./auth-signup-success.vue?vue&type=style&index=0&id=5b895e88&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b895e88"]])

export default __exports__